<template>
    <el-container>
       <img class="banner" src="../assets/img/business.jpg">
       <div class="bg-box">
           <el-aside width="315px">
            <left-menu :menuList="menuList" @activeMeun="activeMeun" :activeMenuIndex="activeMenu"></left-menu>
           </el-aside>
           <div class="right-text">
                <div class="title1">{{activeText}}</div>
                <div class="title2">{{activeTextEng}}</div>
                <el-divider></el-divider>
                <span class="container-box" v-show="activeText == '福保服务'">
                    <div class="left-bg">
                        <div class="left-box"
                         v-for="(item , index) in newsList" 
                         :key="index" @click="toDetails(index)">
                            <span class="title">{{item.title}}</span>
                            <el-divider direction="vertical"></el-divider>
                            <span class="text">{{item.text}}</span>
                        </div>
                    </div>
                    <img src="../assets/img/business1.jpg">
                </span>
                <span class="advant-box" v-show="activeText == '福保优势'">
                    <div class="advant-class" v-for="(item , idx) in advantList" :key="idx">
                        <div class="title">{{item.title}}</div>
                        <span class="text">{{item.text}}</span>
                    </div>
                </span>
                <span class="partner-box" v-show="activeText == '合作伙伴'">
                    <img src="../assets/img/home11.png">
                    <img src="../assets/img/home12.png">
                    <img src="../assets/img/home15.png">
                    <img src="../assets/img/partner1.jpg">
                    <img src="../assets/img/partner2.jpg">
                    <img src="../assets/img/partner3.jpg">
                    <img src="../assets/img/partner4.jpg">
                    <img src="../assets/img/partner5.jpg">
                    <img src="../assets/img/partner6.jpg">
                    <img src="../assets/img/partner7.jpg">
                    <img src="../assets/img/partner8.jpg">
                    <img src="../assets/img/partner9.jpg">
                    <img src="../assets/img/partner10.jpg">
                    <img src="../assets/img/partner11.jpg">
                    <img src="../assets/img/partner12.jpg">
                    <img src="../assets/img/partner13.jpg">
                    <img src="../assets/img/partner14.jpg">
                    <img src="../assets/img/partner15.jpg">
                    <img src="../assets/img/partner16.jpg">
                    <img src="../assets/img/partner18.jpg">

                </span>
           </div>
       </div>
       
    </el-container>
</template>

<script>
import leftMenu from '@/components/leftMenu';
export default {
    name:'business',
    components: {
        leftMenu,
    },
    data() {
        return {
           menuList:['福保服务','福保优势','合作伙伴'],
           activeText: '',
           activeMenu:0,
           newsList:[
               {
                   title:'健康服务',
                   text: '重疾后，和谐健康提供高额保险金，医疗机构提供医疗与疾病管理服务；保险'
               },
               {
                   title:'产品服务',
                   text: '我们所合作的保险公司累计拥有全系列保障产品300余款，其中包括：少儿保障'
               },
               {
                   title:'需求服务',
                   text: '福保经纪拟合作的保险公司类别有：寿险公司、财险公司及养老险公司，同时有'
               },
               {
                   title:'外部服务',
                   text: '服务的维度首要则是“外部服务”，即：以“换位思考、真诚、满足”建设面向公'
               },
               {
                   title:'内部服务',
                   text: '服务的另一个维度是内部服务，即：以“效率、结果、友情”建设面向公司同事的'
               },
               {
                   title:'产品设计',
                   text: '经纪公司相当于保险中介，和保险公司合作，给客户定制保险方案，推荐产品。'
               },
               {
                   title:'再保险',
                   text: '经纪公司还有另一个优势，是保险公司不具备的，即：经纪公司可以做再保险业务。'
               }
           ],
           advantList:[
               {
                   title:'资源整合的直营模式',
                   text: '借和谐健康机构及自身业务目标，全国网点铺设，打造主体公司与中介机构协同发展，资源整合，为客户提供全面的保险保障'
               },
               {
                   title:'科技赋能的三高团队',
                   text: '打造高素质、高产能、高留存的组织，职员制与代理制混合模式，提高留存，强化归属感，荣誉感'
               },
               {
                   title:'大规模的渠道化建设',
                   text: '依托大规模的渠道建设，推动渠道营销和顾销模式，打造全流程的客户服务体系'
               },
               {
                   title:'全流程客户服务体验',
                   text: '借科技赋能，打造福保经纪电商平台，走科技营销与线下结合的模式，用多元化的营销模式满足不同客户的销售需求及购买体验'
               }
           ],
        };
    },
    
   
    computed:{
        activeTextEng(){
            switch (this.activeText) {
                case '福保服务':
                        return 'FUBAO SERVICE'
                    break;
                case '福保优势':
                        return 'FUBAO ADVANTAGE'
                    break;
                case '合作伙伴':
                        return 'COOPERATIVE PARTNER'
                    break;
               
                default:
                    break;
            }
        }
    },
    mounted(){
        this.$nextTick(()=>{
            // location.reload()
        })
    },
    beforeDestroy(){
        this.$route.query.activeText = '福保服务'
    },
    created(){
        this.$nextTick(()=>{
             if(this.$route.query.activeText){
                  switch (this.$route.query.activeText) {
                    case '福保服务':
                         this.activeText = this.$route.query.activeText
                         this.activeMenu = 0
                        //  sessionStorage.setItem("homeActiveIndex", '业务介绍');
                        break;
                     case '福保优势':
                         this.activeText = this.$route.query.activeText
                         this.activeMenu = 1
                        break;
                
                    default:
                        break;
                }
               sessionStorage.setItem("activeClass", 2);
            }
             window.scrollTo(0,0);
           
         })
    },
    methods:{
        activeMeun(data){
            this.activeText = data;
        },
        toDetails(index){
             this.$router.push({
                    path:'businessDetail',
                    query: {indexF:index}
                })
        },
    },
}
</script>
<style lang="scss" scoped>
/deep/ .el-aside{
        overflow: hidden;
    }
/deep/ .el-divider{
        background-color: $font-color-gary2;
        margin-bottom: 20px;
           
}
/deep/ .el-divider--vertical{
    height: 1.4em;
    width: 2px;
}
.el-container{
    flex-wrap: wrap;
}
.banner{
    margin-bottom: 30px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
}
.bg-box{
    width: 100%;
    min-width: 1100px;
    box-sizing: border-box;
    display: flex;
    margin: 0 12%;
    .right-text{
         max-width: 964px;
        min-width: 680px;
        text-align: left;
         margin: 0 0 100px 50px;
         .title1{
            margin: 0px 0 4px 0;
            font-size: $font-size-lv1;
            color: $font-color-main;
          }
         .title2{
            margin: 0 0 35px 0;
            font-size: $font-size-lv5;
            color: $font-color-gary1;
         }
         span{
              font-size: $font-size-lv3;
              color: $font-color-gary1;
                  line-height: 36px;
                 
         }
    }
    .container-box{
        width: 100%;
        display: flex;
        max-width: 964px;
        min-width: 520px;
        img{
            width: 210px;
            height: 328px;
        }
        .left-bg{
            max-width: 743px;
            min-width: 520px;
            max-height: 830px;
            margin: 0 10px 100px 0;
            overflow-y: auto;
            overflow-x: hidden;
        }
        .left-box{
            display: flex;
            max-width: 743px;
            // min-width: 550px;
            height: 32px;
            border: 2px solid $font-color-gary3;
            margin-bottom: 5px;
            padding: 21px 30px 21px 25px;
            cursor: pointer;
            /deep/ .el-divider{
                 margin: 6px 15px 0 22px;
            }
        }
        .title{
            min-width: 32px;
            max-width: 34px;
            height: 40px;
            line-height: 20px;
            font-size: $font-size-lv4;
            color: $font-color-main;
            font-weight: 600;
            display: inline-block;
        }
        .text{
            color: $font-color-black;
            font-size: 18px;
            width: 623px;
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
        }
    }
      .advant-box{
            width: 960px;
            min-width: 780px;
        .advant-class{
                margin-bottom: 40px;
            .title{
                width: 100%;
                font-size: $font-size-lv3;
                color: $font-color-red;
                text-align: left;
                font-weight: 600;
            }
            .text{
                font-size: $font-size-lv4;
            }
        }
    }
    .partner-box{
        max-width: 980px;
        display: flex;
        flex-wrap: wrap;
        img{
            width: 232px;
            height: 104px;
            // margin: 0 13px 15px 0;
            margin: 0 5px 8px 0;
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/views/business.vue